import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { SafeHtml } from '../../_helpers/transform/safe-html.transform';

/** @deprecated Use `showModal` from `@app/react/dialogs/showModal` */
@Component({
  selector: 'app-textdialog',
  templateUrl: './textdialog.component.html',
  styleUrls: ['./textdialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeHtml],
})
export class TextDialogComponent implements OnInit {
  translateTest = inject(TranslateService);
  modalRef = inject(BsModalRef);

  data = {
    title: '',
    text: '',
    button_confirm_text: undefined,
    button_cancel_text: undefined,
  };
  private onCloseSubject!: Subject<boolean>;
  onClose!: Observable<boolean>;

  ngOnInit(): void {
    this.onCloseSubject = new Subject();
    this.onClose = this.onCloseSubject.pipe(throttleTime(500)); // prevent double click from triggering onClose multiple times
  }

  onConfirm(): void {
    this.onCloseSubject.next(true);
    this.modalRef.hide();
  }

  onCancel(): void {
    this.onCloseSubject.next(false);
    this.modalRef.hide();
  }

  /** @deprecated Use `showModal` from `@app/react/dialogs/showModal`. */
  static showDialogTranslated(
    translate: TranslateService,
    modalService: BsModalService,
    title?: string,
    text?: string,
    ok?: string,
    cancel?: string,
    additionalText?: string,
    modalClass?: string,
    translateParams?: object,
  ): Promise<BsModalRef<TextDialogComponent>> {
    return new Promise<BsModalRef<TextDialogComponent>>((resolve) => {
      const resourceArray = [];

      if (title) {
        resourceArray.push(title);
      }

      if (text) {
        resourceArray.push(text);
      }

      if (ok) {
        resourceArray.push(ok);
      }

      if (cancel) {
        resourceArray.push(cancel);
      }

      firstValueFrom(translate.get(resourceArray, translateParams)).then((res) => {
        const titleRes = title ? res[title] : '';
        let textRes = text ? res[text] : '';
        const okRes = ok ? res[ok] : undefined;
        const cancelRes = cancel ? res[cancel] : undefined;

        if (additionalText) {
          textRes += additionalText;
        }

        const modalRef = modalService.show(TextDialogComponent, {
          class: modalClass,
          ignoreBackdropClick: true,
          keyboard: false,
          initialState: {
            data: {
              title: titleRes,
              text: textRes,
              button_confirm_text: okRes,
              button_cancel_text: cancelRes,
            },
          },
        });
        resolve(modalRef);
      });
    });
  }
}
